import PeopleIcon from '@mui/icons-material/People'
import Badge from '@mui/icons-material/Badge'
import DashboardIcon from '@mui/icons-material/Dashboard'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic'
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import PriceCheckIcon from '@mui/icons-material/PriceCheck'
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary'
import ReceiptIcon from '@mui/icons-material/Receipt'
import NotificationAddIcon from '@mui/icons-material/NotificationAdd'
import PublicIcon from '@mui/icons-material/Public'
import EmailIcon from '@mui/icons-material/Email'
import SettingsIcon from '@mui/icons-material/Settings'
import FileCopyIcon from '@mui/icons-material/FileCopy'
import CampaignIcon from '@mui/icons-material/Campaign'
import RssFeedIcon from '@mui/icons-material/RssFeed'
import SellIcon from '@mui/icons-material/Sell'
import GTranslateIcon from '@mui/icons-material/GTranslate';
import QuizIcon from '@mui/icons-material/Quiz'
import TuneIcon from '@mui/icons-material/Tune'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import AdUnitsIcon from '@mui/icons-material/AdUnits'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
export const sidebarNav = [
  {
    moduleId: '1',
    name: 'Dashboard',
    path: '/',
    icon: <DashboardIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '4',
    name: 'User Manager',
    path: '/user-manager',
    icon: <PeopleIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '4',
    name: 'Grade Manager',
    path: '/grade-manager',
    icon: <Badge className='margin-right-1-rem' />
  },
  {
    moduleId: '4',
    name: 'Grade Change Log',
    path: '/grade-change-log',
    icon: <Badge className='margin-right-1-rem' />
  },
  {
    moduleId: '9',
    name: 'Video Manager',
    path: '/video-manager',
    icon: <VideoLibraryIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '9',
    name: 'Video Count By Language',
    path: '/video-manager/language-count',
    icon: <VideoLibraryIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '35',
    name: 'Bank Withdraw Manager',
    path: '/bank-withdraw-manager',
    icon: <AdUnitsIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '19',
    name: 'Global Settings',
    path: '/global-setting-manager',
    icon: <SettingsIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '2',
    name: 'Role Manager',
    path: '/role-manager',
    icon: <TuneIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '3',
    name: 'Promo Video Manager',
    path: '/promo-video-manager',
    icon: <TuneIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '4',
    name: 'User Location Analytics',
    path: '/user-location-analytics',
    icon: <PublicIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '4',
    name: 'Inviter Manager',
    path: '/inviter-manager',
    icon: <Badge className='margin-right-1-rem' />
  },
  {
    moduleId: '5',
    name: 'Influencer Manager',
    path: '/influencer-manager',
    icon: <AccessibilityNewIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '31',
    name: 'Special Reward Manager',
    path: '/special-reward-manager',
    icon: <EmojiEventsIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '32',
    name: 'Reward Clam Manager',
    path: '/special-reward-clam-manager',
    icon: <EmojiEventsIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '33',
    name: 'Reward Info Manager',
    path: '/reward-info-manager',
    icon: <AccountBalanceIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '34',
    name: 'Get Help Manager',
    path: '/get-help-manager',
    icon: <AccountBalanceIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '38',
    name: 'Referral Manager',
    path: '/referral-manager',
    icon: <AccountBalanceIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '6',
    name: 'Sub Admin Manager',
    path: '/sub-admin-manager',
    icon: <AdminPanelSettingsIcon className='margin-right-1-rem' />
  },
  // {
  //   moduleId: '16',
  //   name: 'Category Manager',
  //   path: '/country-manager',
  //   icon: <PublicIcon className='margin-right-1-rem' />
  // },
  {
    moduleId: '7',
    name: 'Report Abuse Manager',
    path: '/report-abuse-manager',
    icon: <ReportProblemIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '8',
    name: 'Chips Purchase Manager',
    path: '/beads-purchase-manager',
    icon: <PriceCheckIcon className='margin-right-1-rem' />
  },
  // {
  //   moduleId: '11',
  //   name: 'Post Manager',
  //   path: '/video-manager',
  //   icon: <VideoLibraryIcon className='margin-right-1-rem' />
  // },
  {
    moduleId: '10',
    name: 'Transaction Manager',
    path: '/transaction-manager',
    icon: <ReceiptIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '11',
    name: 'In App Purchase Manager',
    path: '/app_packages-manager',
    icon: <ReceiptIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '12',
    name: 'Meishe Assets Manager',
    path: '/meishe-assets-manager',
    icon: <AdUnitsIcon className='margin-right-1-rem' />
  },
  // {
  //   moduleId: "4",
  //   name: "Filter Manager",
  //   path: "/filter-manager",
  //   icon: <PhotoFilterIcon className="margin-right-1-rem" />,
  // },
  // {
  //   moduleId: "5",
  //   name: "Font & Style Manager",
  //   path: "/font-style-manager",
  //   icon: <FormatColorTextIcon className="margin-right-1-rem" />,
  // },
  // {
  //   moduleId: "6",
  //   name: "Effects Manager",
  //   path: "/effect-manager",
  //   icon: <FlareIcon className="margin-right-1-rem" />,
  // },
  {
    moduleId: '13',
    name: 'Sound Manager',
    path: '/sound-manager',
    icon: <LibraryMusicIcon className='margin-right-1-rem' />
  },
  // {
  //   moduleId: "8",
  //   name: "Widget Manager",
  //   path: "/widget-manager",
  //   icon: <WidgetsIcon className="margin-right-1-rem" />,
  // },

  // {
  //   name: 'Coin Manager',
  //   path: '/coin-manager',
  //   icon: <TollIcon className='margin-right-1-rem' />
  // },

  // {
  //   moduleId: '12',
  //   name: 'Streaming Manager',
  //   path: '/streaming-manager',
  //   icon: <CastIcon className='margin-right-1-rem' />
  // },

  // {
  //   moduleId: "14",
  //   name: "Report Manager",
  //   path: "/report-manager",
  //   icon: <SummarizeIcon className="margin-right-1-rem" />,
  // },
  {
    moduleId: '14',
    name: 'Notification Manager',
    path: '/notification-manager',
    icon: <NotificationAddIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '15',
    name: 'Country Manager',
    path: '/country-manager',
    icon: <PublicIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '16',
    name: 'State Manager',
    path: '/state-manager',
    icon: <PublicIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '17',
    name: 'City Manager',
    path: '/city-manager',
    icon: <PublicIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '18',
    name: 'District Manager',
    path: '/district-manager',
    icon: <PublicIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '19',
    name: 'App Version Config',
    path: '/app-version-config-manager',
    icon: <SettingsIcon className='margin-right-1-rem' />
  },
  // {
  //   moduleId: '16',
  //   name: 'Language Manager',
  //   path: '/country-manager',
  //   icon: <PublicIcon className='margin-right-1-rem' />
  // },
  {
    moduleId: '20',
    name: 'Email Templates',
    path: '/email-manager',
    icon: <EmailIcon className='margin-right-1-rem' />
  },

  {
    moduleId: '21',
    name: 'Static Content',
    path: '/static-content-manager',
    icon: <FileCopyIcon className='margin-right-1-rem' />
  },
  // {
  //   moduleId: "20",
  //   name: "Geo Location Manager",
  //   path: "/geo-location-manager",
  //   icon: <EditLocationAltIcon className="margin-right-1-rem" />,
  // },
  {
    moduleId: '22',
    name: 'Ads Management',
    path: '/ads-manager',
    icon: <CampaignIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '23',
    name: 'Blogs Management',
    path: '/blog-manager',
    icon: <RssFeedIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '24',
    name: 'Category Manager',
    path: '/tag-manager',
    icon: <SellIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '25',
    name: 'Influencer Category',
    path: '/influencer-category-manager',
    icon: <SellIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '26',
    name: 'Language Manager',
    path: '/language-manager',
    icon: <GTranslateIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '27',
    name: 'FAQ Manager',
    path: '/faq-manager',
    icon: <QuizIcon className='margin-right-1-rem' />
  },
  // {
  //   moduleId: '25',
  //   name: 'Rate Application Manager',
  //   path: '/rating-manager',
  //   icon: <StarRateIcon className='margin-right-1-rem' />
  // },
  {
    moduleId: '28',
    name: 'Withdraw Manager',
    path: '/withdraw-manager',
    icon: <AccountBalanceIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '29',
    name: 'Banner Manager',
    path: '/banner-manager',
    icon: <AdUnitsIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '30',
    name: 'Event Manager',
    path: '/event-manager',
    icon: <AdUnitsIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '31',
    name: 'Upi Withdraw Manager',
    path: '/upi-withdraw-manager',
    icon: <AdUnitsIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '32',
    name: 'Chips Wallet Manager',
    path: '/chips-wallet-manager',
    icon: <AccountBalanceIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '33',
    name: 'Cash Wallet Manager',
    path: '/cash-wallet-manager',
    icon: <AccountBalanceIcon className='margin-right-1-rem' />
  },
  {
    moduleId: '34',
    name: 'Shopping Manager',
    path: '/shopping-manager',
    icon: <ShoppingCartIcon className='margin-right-1-rem' />
  }
]
